document.addEventListener('DOMContentLoaded', () => {
  const bannerSlider = document.querySelector('.banner__slider');

  if (!bannerSlider) return;

  let height = window.isMobile() ? 64 : 128;
  let n = 0;
  let timerId = null;

  window.addEventListener('resize', () => {
    height = window.isMobile() ? 64 : 128;
  });

  const startCountdown = () => {
    const slides = document.querySelectorAll('.banner__slide');

    n = (n + 1) % slides.length;

    timerId = setTimeout(() => {
      const wrapper = document.querySelector('.banner__wrapper');

      if (wrapper) {
        wrapper.style.transform = `translateY(-${n * height}px)`;
      }

      if (slides.length) {
        startCountdown();
      }
    }, 3000);
  };

  const stopCountdown = () => {
    if (timerId) {
      clearTimeout(timerId);
      timerId = null;
    }
  };

  // Clean up timer when component is removed or page unloads
  document.addEventListener('turbo:before-render', stopCountdown);
  window.addEventListener('beforeunload', stopCountdown);

  startCountdown();
});

// Therapy type toggle functionality
document.addEventListener('DOMContentLoaded', () => {
  const toggles = document.querySelectorAll('.banner__toggle');

  if (toggles.length === 0) return;

  // Read saved value from localStorage
  const couple = localStorage.getItem('yasno_couple') ? JSON.parse(localStorage.getItem('yasno_couple')) : false;

  // Set initial state for all toggles
  toggles.forEach((toggle) => {
    toggle.checked = couple;
  });

  // Add change listeners to sync all toggles and save to localStorage
  toggles.forEach((toggle) => {
    toggle.addEventListener('change', function () {
      // Sync all toggles to the same state
      toggles.forEach((t) => t.checked = this.checked);

      // Save to localStorage
      localStorage.setItem('yasno_couple', this.checked);
    });
  });
});
